<div class="offering-installations">
  <h1 class="ui-heading-1-bold offering-installations-title">
    {{ OFFERING_FORM.DETAILS.INSTALLATION.SECTION_TITLE }}
  </h1>
  <h3 class="ui-heading-3">{{ OFFERING_FORM.DETAILS.INSTALLATION.SECTION_HEADING }}</h3>

  <div class="cards">
    @for (installation of installationInformation(); track $index) {
      <inexp-teaser-card
        [title]="installation.applicationType"
        [description]="installation.instructions"
        [primaryBtn]="installation.url"
      ></inexp-teaser-card>
    }
  </div>
</div>
